<template>
    <div v-if="rating > 1" class="relative inline-flex gap-0.5 lg:mb-5 whitespace-nowrap">
        <span v-for="index in 5" :key="index">
            <full-star :class="starCss" v-if="rating>=index" />
            
            <point-one-two-star :class="starCss" v-else-if="isFraction(index, 0.1, 0.2)" />
            <point-three-four-star :class="starCss" v-else-if="isFraction(index, 0.3, 0.4)" />
            <half-star :class="starCss" v-else-if="isFraction(index, 0.5)" />
            <point-six-seven-star :class="starCss" v-else-if="isFraction(index, 0.6, 0.7)" />
            <point-eight-nine-star :class="starCss" v-else-if="isFraction(index, 0.8, 0.9)" />

            <empty-star :class="starCss" v-else />
        </span>
    </div>
</template>
<script>
import {defineComponent} from 'vue'
import EmptyStar from './rating-stars/EmptyStar.vue'
import FullStar from './rating-stars/FullStar.vue'
import HalfStar from './rating-stars/HalfStar.vue'
import PointOneTwoStar from './rating-stars/PointOneTwoStar.vue'
import PointThreeFourStar from './rating-stars/PointThreeFourStar.vue'
import PointSixSevenStar from './rating-stars/PointSixSevenStar.vue'
import PointEightNineStar from './rating-stars/PointEightNineStar.vue'

export default defineComponent({
    components: {
        EmptyStar,
        FullStar,
        HalfStar,
        PointOneTwoStar,
        PointThreeFourStar,
        PointSixSevenStar,
        PointEightNineStar,
    },
    props: {
        rating: {
            type: String,
            default: "0",
        },
    },
    data: () => ({
        starCss: ' w-5 lg:w-6 h-5 lg:h-6 ',
    }),
    computed: {
        cover() {
            let cover = 5 - parseFloat(this.rating)
            let coverPercentage = (100*cover) / 5

            return coverPercentage
        },
    },
    methods: {
        isFraction(index, ...fractions) {
            const fraction = parseFloat((this.rating - index + 1).toFixed(1));
            return fractions.includes(fraction);
        }
    }
});
</script>
